var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'relative flex flex-col items-center border border-brand-purple-500 cursor-pointer rounded px-5 py-4',
    _vm.selected ? 'bg-brand-purple-100/25' : '',
    _vm.hasIcon ? 'form-selector-large-default' : 'form-selector-small-default'
  ]},[(this.$attrs.icon)?_c('n-icon',{staticClass:"mb-3",attrs:{"xl":"","auto":"","name":this.$attrs.icon}}):_vm._e(),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(this.$attrs.text))]),(_vm.selected)?_c('n-icon',{staticClass:"absolute top-2 right-2",attrs:{"small":"","name":"Check"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }